var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmcPhoneAppTheGramDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.81 2.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3c3c3b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.43,1.21c0,.67-.54,1.21-1.21,1.21S0,1.89,0,1.21,.54,0,1.21,0s1.21,.54,1.21,1.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.12,1.21c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21,.54-1.21,1.21-1.21,1.21,.54,1.21,1.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.81,1.21c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21,.54-1.21,1.21-1.21,1.21,.54,1.21,1.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmcPhoneAppTheGramDots);
export default __webpack_public_path__ + "static/media/MMC_Phone App_TheGram_Dots.132dd489e3fc136bcaf8268895d2b81c.svg";
export { ForwardRef as ReactComponent };